// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--hVK7S","icon":"icon--mNSnV","fadeIn":"fadeIn--BnpJE","ratio":"ratio--PwfGn","fadeSlideUp":"fadeSlideUp--loBNb"};